import { isAxiosError } from "axios";

/**
 * User-facing toast copy for a failed "Add to my workspace" copy request,
 * keyed off the copy endpoint's error contract (400/403/404/500).
 */
export function addToWorkspaceErrorMessage(error: unknown): string {
  const status = isAxiosError(error) ? error.response?.status : undefined;
  switch (status) {
    case 401:
      return "Your session expired. Please log in and try again.";
    case 403:
      return "You do not have permission to add canvases to that workspace.";
    case 404:
      return "This canvas is no longer published.";
    default:
      return "Failed to add canvas. Please try again.";
  }
}
